import {FC, HTMLAttributes} from 'react';
import clsx from 'clsx';
import {keyValueGrid} from './styles.module.css';

export type KeyValueProps = HTMLAttributes<HTMLDivElement> & {
    className?: string;
    /* keyWidth is in rem */
    keyWidth?: number;
};

const KeyValue: FC<KeyValueProps> = ({className, keyWidth, ...rest}) => (
    <div
        className={clsx('side-by-side', keyValueGrid, className)}
        style={
            keyWidth
                ? {
                      gridTemplateColumns: `${keyWidth}rem minmax(0, max-content)`,
                  }
                : undefined
        }
        {...rest}
    />
);

export default KeyValue;
